/* eslint-disable flowtype/require-valid-file-annotation */
// this is an old format export so it can be imported in the nodejs files inside
// ./gatsby-node to keep the strings all in one place
module.exports = Object.freeze({
  AGGREGATE_NEWS_PAGE: 'aggregate_news_page',
  AUTO_MODAL_CONFIG: 'auto_modal_config',
  ANGLED_BACKGROUND_GROUP: 'angled_background_group',
  BOOKMARK: 'bookmark',
  BLOG_AGGREGATE_CATEGORY: 'blog_aggregate_category',
  BLOG_AGGREGATE_PAGE: 'blog_aggregate_page',
  BLOG_AGGREGATE_POSTS: 'blog_aggregate_posts',
  BLOG_CONFIG: 'blog_config',
  BLOG_CONVERSATION_SPEAKER: 'blog_conversation_speaker',
  BLOG_IMAGE: 'blog_image',
  BLOG_PARAGRAPH: 'blog_paragraph',
  BLOG_POST: 'blog_post',
  BLOG_QUOTE: 'blog_quote',
  CARD_IMAGE: 'card_image',
  CARD_LARGE_IMAGE: 'card_large_image',
  CARD_SIMPLE_CONTENT: 'card_simple_content',
  CARDS: 'cards',
  CALLOUT: 'callout',
  CATEGORY: 'category',
  COMPANY_PROFILE: 'company_profile',
  COUNTRY: 'country',
  FOOTER: 'custom_footer',
  FORM_BUTTON: 'form_button',
  FORM_SELECT: 'form_select',
  FORM_REQUEST_TYPE: 'form_request_type',
  FORM_FIELD: 'form_field',
  HEADER: 'custom_header',
  // NOT a storyblok component, only used to include locale redirect logic
  I18N_REDIRECT_PAGE: 'i18n_redirect_page',
  IMAGE: 'image',
  IMAGE_BLOCK: 'image_block',
  JOB: 'job',
  JOBS_CONFIG: 'jobs_config',
  LAYOUT: 'layout',
  LINK: 'link',
  LINK_LIST: 'link_list',
  LINKED_IMAGE_LIST: 'linked_image_list',
  LINKED_IMAGE: 'linked_image',
  MODAL: 'modal',
  MODAL_PAGE: 'modal_page',
  MODAL_PAGE_LARGE: 'modal_page_large',
  MODAL_PAGE_SMALL: 'modal_page_small',
  MODAL_PAGE_STATIC: 'modal_page_static',
  NAVIGATION_ITEM: 'navigation_item',
  PAGE: 'page',
  PORTAL_PAGE: 'portal_page',
  PARAGRAPH_WITH_IMAGE: 'paragraph_with_image',
  PHONE_INPUT_SETTINGS: 'phone_input_settings',
  PROFILE: 'profile',
  REDIRECT_PAGE: '301_redirect',
  SIMPLE_CONTENT: 'simple_content',
  SIMPLE_CONTENT_BLOCK: 'simple_content_block',
  SIMPLE_CONTENT_CALLOUT: 'simple_content_callout',
  SHOP: 'shop',
  SHOP_LIST: 'shop_list',
  STATIC_CONTENT: 'static_content',
  SUBSCRIBE_FORM_BLOCK: 'subscribe_form_block',
  TABLE: 'table',
  TEAM: 'team',
  TEAM_PROFILE: 'team_profile',
  TEMPLATE_PARAGRAPH: 'template_paragraph',
  TESTIMONIAL: 'testimonial',
  TESTIMONIAL_BLOCK: 'testimonial_block',
  TITLE_WITH_DESCRIPTION: 'title_with_description',
  UNKNOWN_COUNTRY_LOADER: 'unknown_country_loader',
  YOUTUBE_VIDEO: 'youtube_video'
});
